'use client'

import {
  setProductOrder,
  setProductSelectedSortOption,
} from '@/app/globalRedux/filter/productFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import SearchResultSort from '@/components/SearchResultSelect'
import { openModal } from '@/lib/filterMobileModalHandler'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FruitVegetableFilter from '../../(Filters)/HeaderFilter/FruitVegetableFilter'
import PrePostHarvestFilter from '../../(Filters)/HeaderFilter/PrePostHarvestFilter'
import TransPortLogitcsFilter from '../../(Filters)/HeaderFilter/TransPortLogitcsFilter'
import ProductFilter from '../../(Filters)/ProductFilter/ProductFilter'

const ProductListingHeader = () => {
  const [tabName, setTabName] = useState<string>('')
  const pathName = usePathname()
  const dispatch = useDispatch()
  const commonFilter = useSelector((state: RootState) => state.commonFilter)

  const productFilter = useSelector((state: RootState) => state.productFilter)
  const { order: productOrder, productSelectedSortOption } = useSelector(
    (state: RootState) => state.productFilter
  )
  const { t } = useTranslation()

  useEffect(() => {
    const url = window.location.href

    const urlPath = url.split('/')
    if (urlPath.includes('buyers-listing')) {
      setTabName(t(`Buyers Alert`))
    } else if (urlPath.includes('sales-listing')) {
      setTabName(t('Sales Offers'))
    }
  }, [pathName])
  const getCount = () => {
    switch (productFilter.sector) {
      case 'Fruit & Vegetable':
        return (
          productFilter?.cultivationType?.length +
          commonFilter?.productLocation?.length +
          commonFilter?.productLocationContients?.length +
          productFilter?.productFruitVegetableActivity?.length +
          (productFilter?.productFVAvailability?.length ? 1 : 0) +
          commonFilter?.companyLocation?.length +
          commonFilter?.companyLocationContinents?.length +
          productFilter?.productFilterFvSelectedProducts?.length
        )
      case 'Pre - Post Harvest':
        return (
          productFilter?.productFilterPpSelectedProducts?.length +
          commonFilter?.companyLocationContinents?.length +
          commonFilter?.companyLocation?.length
        )
      case 'Transport / Logistics':
        return (
          commonFilter?.companyLocation?.length +
          commonFilter?.companyLocationContinents?.length +
          productFilter?.productFilterTlSelectedProducts?.length
        )
    }
  }
  return (
    <div className=" mb-4 mobile:mb-[10px]">
      <div className="flex flex-row justify-center mb-[20px] items-center mobile:mb-[10px]">
        <div>{tabName}</div>
        <div className="ml-auto mobile:block hidden">
          <Image
            onClick={() => openModal('product-modal')}
            loading="lazy"
            width={30}
            height={30}
            src="/assets/Icons/mobile-filter-icon.svg"
            alt="filter-icon"
            className="border-[#ddd] border-solid bg-[#F4F4F4] px-[5px] py-[5px] rounded"
          />

          <div
            id="product-modal"
            className="modal-hidden fixed top-0 left-0 z-50 w-full h-full flex items-center justify-center bg-gray-900 bg-opacity-50 overflow-y-hidden"
          >
            <div className="bg-white rounded-lg overflow-y-auto shadow-xl transform transition-all sm:max-w-lg sm:w-full mobile:h-[80vh] mobile-width mobile:py-[10px] mobile:px-[10px]">
              <ProductFilter />
            </div>
          </div>
        </div>
        <div className="ml-auto mobile:ml-[20px]">
          <div className="mobile:hidden">
            <SearchResultSort
              options="productSort"
              selectedOption={productSelectedSortOption}
              sortByFunction={(value) => {
                dispatch(setProductSelectedSortOption(value))
              }}
              order={productOrder}
              orderByFunction={(value) => {
                dispatch(setProductOrder(value))
              }}
            />
          </div>
        </div>
      </div>
      <div className=" mt-5 border-t-2 border-t-[#e6e6e6] border-solid mobile:mt-[10px]">
        <div className=" flex flex-row gap-[2px] mt-5 mobile:flex-col mobile:gap-[10px] mobile:mt-[10px]">
          {getCount() !== 0 && (
            <div className="gap-[0px] flex flex-row mr-[5px] items-center">
              <p className="text-[#6f6f6f] text-[14px] font-medium w-max">
                {t(`Filters Applied`)}
              </p>
            </div>
          )}
          {productFilter.sector == 'Fruit & Vegetable' && (
            <FruitVegetableFilter />
          )}
          {productFilter.sector == 'Pre - Post Harvest' && (
            <PrePostHarvestFilter />
          )}
          {productFilter.sector == 'Transport / Logistics' && (
            <TransPortLogitcsFilter />
          )}
          <div className="text-[#fff] ml-1 text-sm font-medium text-orange">
            <p>{(getCount() ?? 0) > 2 && `+${(getCount() ?? 0) - 2}`}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductListingHeader
